import { render } from "./push_update.vue?vue&type=template&id=59334075&scoped=true"
import script from "./push_update.vue?vue&type=script&lang=js"
export * from "./push_update.vue?vue&type=script&lang=js"

import "./push_update.vue?vue&type=style&index=0&id=59334075&scoped=true&lang=css"

import exportComponent from "F:\\code\\my_business\\giaiphapmmo_business_2023\\front_end\\company_for_tax\\admin_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59334075"]])

export default __exports__